import React, { FC } from "react";
import { ReactComponent as InstallSVG } from "../../../../../../../../images/svg/subscriptions/install.svg";
import { PriceConfiguratorContentApi } from "../../../../../../../../services/Api/types";
import { RenderApplicationLogo } from "../../../../../../components/RenderApplicationLogo/RenderApplicationLogo";

interface Props {
	config: PriceConfiguratorContentApi;
	onAdd: (config: PriceConfiguratorContentApi) => void;
}

const InactiveSubscription: FC<Props> = ({ config, onAdd }) => {
	const areAllPlansReadonly = config.plans.every((x) => x.edit_mode !== "EDITABLE");

	return (
		<div className={"card subscription-card inactive"}>
			<div className={"header"}>
				<div className={"d-flex align-items-center gap-2"}>
					<RenderApplicationLogo slug={config.family_id} />
					<h5>{config.name}</h5>
				</div>
				<div className={"header-actions"}>
					<InstallSVG
						className={`${areAllPlansReadonly && "disabled-svg"}`}
						onClick={() => {
							if (!areAllPlansReadonly) onAdd(config);
						}}
					/>
				</div>
			</div>
			<div className={"addon-description"}>{config.description}</div>
		</div>
	);
};
export default InactiveSubscription;
